export function flyTo(mapRef, popupRef, location, zoom=14) {
  if (!location.length) return;
	mapRef.flyTo([location[0], location[1]], zoom, {
		animate: true,
		duration: 2
	});
	// popupRef?.current.openPopup();
}
